const exportC = {
    name: "CIcon",
    functional: true, // functional component so it does not render that <div> root
    props: {
        icon: String
    },
    render(h, ctx) {
        return h("i", { class: "fa " + ctx.props.icon });
    }
};
const aliases = {
    complete: "fa-light fa-check",
    cancel: "fa-light fa-circle-xmark",
    close: "fa-light fa-xmark",
    delete: "fa-light fa-xmark", // delete (e.g. v-chip close)
    clear: "fa-light fa-xmark",
    success: "fa-light fa-circle-check",
    info: "fa-light fa-circle-info",
    warning: "fa-light fa-exclamation-circle",
    error: "fa-light fa-exclamation-triangle",
    prev: "fa-solid fa-caret-left",
    next: "fa-solid fa-caret-right",
    checkboxOn: "fa-solid fa-square-check",
    checkboxOff: "fa-light fa-square",
    checkboxIndeterminate: "fa-solid fa-square-minus",
    delimiter: "/", // for carousel
    sort: "fa-light fa-sort",
    expand: "fa-solid fa-circle-chevron-down",
    menu: "fa-solid fa-bars",
    subgroup: "fa-solid fa-caret-down",
    dropdown: "fa-light fa-caret-down",
    radioOn: "fa-solid fa-circle-dot",
    radioOff: "fa-light fa-circle",
    edit: "fa-light fa-pen-to-square",
    ratingEmpty: "",
    ratingFull: "fa-solid fa-star",
    ratingHalf: "fa-solid fa-star-half",
    loading: "fa-light fa-circle-notch fa-spin",
    first: "...",
    last: "...",
    unfold: "...",
    file: "fa-light fa-file",
    // custom aliases! :D
    iconCheckDouble: "fa-solid fa-check-double",
    iconTrash: "fa-light fa-trash-can",
    iconUser: "fa-light fa-user",
    iconInputHiddenOff: "fa-light fa-eye-slash",
    iconInputHiddenOn: "fa-light fa-eye",
    iconDownload: "fa-light fa-arrow-down-to-line",
    iconUpload: "fa-light fa-arrow-up-to-line",
    iconApproved: "fa-light fa-circle-check",
    iconRejected: "fa-light fa-circle-xmark",
    iconApproveThumbs: "fa-light fa-thumbs-up",
    iconDeclineThumbs: "fa-light fa-thumbs-down",
    iconStar: "fa-solid fa-star",
    iconDuplicate: "fa-light fa-copy",
    iconClock: "fa-light fa-clock",
    iconPlus: "fa-solid fa-plus",
    iconMinus: "fa-light fa-minus",
    iconTimes: "fa-light fa-times",
    iconCheck: "fa-light fa-check",
    iconBanned: "fa-light fa-ban",
    iconEye: "fa-light fa-eye",
    iconEyeSlash: "fa-light fa-eye-slash",
    iconPage: "fa-light fa-file",
    iconMoney: "fa-light fa-money-check",
    iconEllipsisV: "fa-light fa-ellipsis-v",
    iconRedo: "fa-light fa-redo-alt",
    iconSync: "fa-light fa-sync",
    iconReset: "fa-light fa-sync",
    iconRefresh: "fa-light fa-sync",
    iconSplit: "fa-light fa-code-branch",
    iconExclamationTriangle: "fa-light fa-exclamation-triangle",
    iconExclamationCircle: "fa-light fa-exclamation-circle",
    iconClipboard: "fa-light fa-clipboard-list",
    iconImage: "fa-light fa-images",
    iconCalendar: "fa-light fa-calendar-days",
    iconExternalLink: "fa-light fa-arrow-up-right-from-square",
    iconTimesCircle: "fa-light fa-circle-xmark",
    iconArrowOutSquare: "fa-light fa-arrow-up-right-from-square",
    iconCircleCheck: "fa-light fa-circle-check",
    iconArrowUp: "fa-light fa-arrow-up",
    iconArrowLeft: "fa-light fa-arrow-left",
    iconArrowDown: "fa-light fa-arrow-down",
    iconArrowRight: "fa-light fa-arrow-right",
    iconCircleArrowRight: "fa-light fa-circle-chevron-right",
    iconCircleArrowLeft: "fa-light fa-circle-chevron-left",
    iconCircleCaretUp: "fa-light fa-circle-chevron-up",
    iconCircleCaretDown: "fa-light fa-circle-chevron-down",
    iconCircleCaretLeft: "fa-light fa-circle-chevron-left",
    iconCircleCaretRight: "fa-light fa-circle-chevron-right",
    iconCaretUp: "fa-light fa-chevron-up",
    iconCaretDown: "fa-light fa-chevron-down",
    iconCaretLeft: "fa-light fa-chevron-left",
    iconCaretRight: "fa-light fa-chevron-right",
    iconBars: "fa-light fa-bars",
    iconMap: "fa-light fa-map-location",
    iconCart: "fa-light fa-cart-shopping",
    iconSearch: "fa-light fa-magnifying-glass",
    iconCommentDots: "fa-light fa-comment-dots",
    iconComment: "fa-light fa-comment",
    iconBell: "fa-light fa-bell",
    iconBellRinged: "fa-light fa-bell-ring",
    iconGlobe: "fa-light fa-globe",
    iconTrophy: "fa-light fa-trophy",
    iconChartBars: "fa-light fa-chart-bar",
    iconRosette: "fa-light fa-award",
    iconReceipt: "fa-light fa-receipt",
    iconEmail: "fa-light fa-envelope",
    iconCopy: "fa-light fa-copy",
    iconPercent: "fa-light fa-percent",
    iconLock: "fa-light fa-lock",
    iconUnlock: "fa-light fa-lock-open",
    iconPrint: "fa-light fa-print",
    iconPlane: "fa-light fa-plane",
    iconAlarmClock: "fa-light fa-alarm-clock",
    iconGear: "fa-light fa-gear",
    iconShuffle: "fa-light fa-shuffle",
    iconBriefcase: "fa-light fa-briefcase",
    iconGuide: "fa-light fa-map",
    iconRecorder: "fa-light fa-video",
    iconRightToBracket: "fa-light fa-right-to-bracket",
    iconA18yIcon: "fa-light fa-glasses",
    iconGuardianContact: "fa-light fa-square-user",
    iconFolder: "fa-light fa-folder",
    iconFolderOpen: "fa-light fa-folder-open",
    iconPencil: "fa-light fa-pencil",
    iconCalendarClock: "fa fa-light fa-calendar-clock",
    iconInvoice: "fa-light fa-file-invoice",
    iconMobile: "fa-light fa-mobile-screen-button",
    iconCircleSmall: "fa-solid fa-circle-small",
    iconDashboard: "fa-light fa-objects-column",
    iconMerge: "fa-light fa-merge",
    iconHundredPoints: "fa-light fa-hundred-points",
    iconBasketShoppingPlus: "fa-light fa-basket-shopping-plus",
    iconBuildingColumns: "fa-light fa-building-columns"
};
export const iconAliases = Object.entries(aliases).reduce((arr, [k, v]) => {
    arr[k] = {
        component: exportC,
        props: {
            icon: v
        }
    };
    return arr;
}, {});
